import React from 'react';
import styled from 'styled-components';
import brideAndGroomIcon from '../assets/images/brideandgroom.svg';
import recepcjaIcon from '../assets/images/recepcja.svg';
import swiadkowieIcon from '../assets/images/swiadkowie.svg';

const ContactSection: React.FC = () => {
  return (
    <Container>
      <ContactItem>
        <Icon src={brideAndGroomIcon} alt="Bride and Groom" />
        <Header className="gwendolyn-font">Panna Młoda i Pan Młody</Header>
        <BrideAndGroomWrapper>
          <Person>
            <TooltipWrapper>
              <SubHeader className="cormorant-font">Natalia</SubHeader>
              <PhoneLink
                id="bride-phone"
                href="tel:+48793792602"
                className="markazi-text-font"
              >
                +48 793 792 602
                <Tooltip>Aby potwierdzić przybycie, zadzwoń na ten numer</Tooltip>
              </PhoneLink>
            </TooltipWrapper>
          </Person>
          <Person>
            <TooltipWrapper>
              <SubHeader className="cormorant-font">Dominik</SubHeader>
              <PhoneLink
                id="groom-phone"
                href="tel:+48784791367"
                className="markazi-text-font"
              >
                +48 784 791 367
                <Tooltip>Aby potwierdzić przybycie, zadzwoń na ten numer</Tooltip>
              </PhoneLink>
            </TooltipWrapper>
          </Person>
        </BrideAndGroomWrapper>
      </ContactItem>

      <ContactItem>
        <Icon src={swiadkowieIcon} alt="Świadkowie" className="swiadkowie-icon" />
        <Header className="gwendolyn-font">Świadkowie</Header>
        <BrideAndGroomWrapper>
          <Person>
            <SubHeader className="cormorant-font">Julia</SubHeader>
            <PhoneLink href="tel:+48668271048" className="markazi-text-font">
              +48 668 271 048
            </PhoneLink>
          </Person>
          <Person>
            <SubHeader className="cormorant-font">Wiktor</SubHeader>
            <PhoneLink href="tel:+48502294859" className="markazi-text-font">
              +48 502 294 859
            </PhoneLink>
          </Person>
        </BrideAndGroomWrapper>
      </ContactItem>

      <ContactItem>
        <Icon src={recepcjaIcon} alt="Recepcja hotelu" className="recepcja-icon" />
        <Header className="gwendolyn-font">Recepcja hotelu</Header>
        <Person>
          <PhoneLink href="tel:+48504211636" className="markazi-text-font">
            +48 504 211 636
          </PhoneLink>
        </Person>
      </ContactItem>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    width: 70px;
    height: 70px;
  }

  &.swiadkowie-icon {
    margin-bottom: 5px; /* Obniżenie ikony o 10px */
  }

  &.recepcja-icon {
    width: 30px; /* Zmniejszenie szerokości o 20px */
    height: 30px; /* Zmniejszenie wysokości o 20px */

    @media (min-width: 768px) {
      width: 50px; /* Zmniejszenie szerokości o 20px na desktopie */
      height: 50px; /* Zmniejszenie wysokości o 20px na desktopie */
    }
  }
`;

const Header = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 5px;

  @media (min-width: 768px) {
    font-size: 2rem;
  }
`;

const SubHeader = styled.h4`
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

const BrideAndGroomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 40px;
  }
`;

const Person = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const Tooltip = styled.span`
  visibility: hidden;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  bottom: 125%; /* Pozycja nad linkiem */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  font-size: 0.9rem;
  white-space: nowrap;

  /* Strzałka pod tooltipem */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }

  ${TooltipWrapper}:hover &,
  ${TooltipWrapper}:focus & {
    visibility: visible;
  }
`;

const PhoneLink = styled.a`
  font-size: 1.2rem;
  color: #007bff;
  text-decoration: none;
  margin: 5px 0;
  position: relative;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export default ContactSection;